import { useCountdown } from '@/src/hooks/useCountdown';
import { i18nKeys } from '@/src/utils/i18n.utils';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

interface CountDownProps {
  targetDate: number;
  format?: 'DHMS' | 'D_hh:mm:ss';
  onExpire?: () => void;
}

const CountDown: React.FC<CountDownProps> = (params) => {
  const { targetDate, onExpire, format = 'DHMS' } = params;
  const { t } = useTranslation();
  const [expired, setExpired] = useState(false);
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  useEffect(() => {
    if (days <= 0 && hours <= 0 && minutes <= 0 && seconds <= 0) {
      setExpired(true);
      onExpire?.();
    }
  }, [days, hours, minutes, seconds]);

  if (expired) {
    return <span className="time-expired">{t(i18nKeys.general.timeExpired)}</span>;
  }

  const dayLabel = days === 1 ? t(i18nKeys.time.day) : t(i18nKeys.time.days);
  const hourLabel = hours === 1 ? t(i18nKeys.time.hour) : t(i18nKeys.time.hours);
  const minuteLabel = minutes === 1 ? t(i18nKeys.time.minute) : t(i18nKeys.time.minutes);
  const secondLabel = seconds === 1 ? t(i18nKeys.time.second) : t(i18nKeys.time.seconds);

  if (format === 'D_hh:mm:ss') {
    return (
      <span className="countdown">
        {days ? `${days} ${dayLabel}` : ''} {hours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}:
        {seconds.toString().padStart(2, '0')}
      </span>
    );
  }
  return (
    <span className="countdown">
      {days ? `${days} ${dayLabel}` : ''} {hours} {hourLabel} {minutes} {minuteLabel} {seconds} {secondLabel}
    </span>
  );
};

export default CountDown;
